import { render, staticRenderFns } from "./FooterAuth.vue?vue&type=template&id=4bc6d5dc&"
import script from "./FooterAuth.vue?vue&type=script&lang=js&"
export * from "./FooterAuth.vue?vue&type=script&lang=js&"
import style0 from "./FooterAuth.vue?vue&type=style&index=0&id=4bc6d5dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports